import { logger } from '$utils'
import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import useStockStore from '../store'
import { InvoiceStatusFilter } from '$constants'
import { parseSortModelToParamString } from '../../../common/helpers'

function loaderFactory({ onlyNonReceived = false } = {}) {
  onlyNonReceived = onlyNonReceived || false

  return async function loader() {
    logger.debug(
      '[loader] About to await AppState being ready in Invoices loader'
    )
    await isAppStateReady()
    logger.debug('[loader] AppState should now be ready in Invoices loader')

    const status = onlyNonReceived
      ? InvoiceStatusFilter.NotReceived
      : InvoiceStatusFilter.Received

    const paginationModel = useStockStore.getState().paginationModel
    const sortParam = parseSortModelToParamString(
      useStockStore.getState().sortModel
    )
    const getInvoices = useStockStore.getState().getInvoices({
      status: status,
      page: paginationModel.page,
      pageSize: paginationModel.pageSize,
      sort: sortParam,
    })
    const getBrands = useStockStore.getState().getBrands()
    const getSuppliers = useStockStore.getState().getSuppliers()

    return defer({
      data: Promise.all([getInvoices, getBrands, getSuppliers])
        .then(() => true)
        .catch((error) => {
          logger.error('Invoices Promise.all error', error)
          return false
        }),
    })
  }
}

export default loaderFactory
